/**
 * @generated SignedSource<<8b5b894162d4e1cd2df65dd8485cc09d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarVariantBase$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsLongReadArticle" | "helpersCheckIsMorningStudioArticle" | "helpersCheckIsPhotoEssayArticle" | "helpersCheckIsPlusPage" | "helpersCheckIsPostiesArticle" | "helpersCheckIsPostiesPage" | "helpersCheckIsStyleArticle" | "helpersSectionContent" | "helpersStyleSectionContent">;
  readonly " $fragmentType": "helpersAppBarVariantBase";
};
export type helpersAppBarVariantBase$key = {
  readonly " $data"?: helpersAppBarVariantBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarVariantBase"
};

(node as any).hash = "49f7d6a639a94685a47fc15531bcd038";

export default node;
